<template>
  <taken-table
    :data="data"
    :loading="isLoading"
    :search-query="searchQuery"
  />
</template>

<script>
import TakenTable from "@/components/guest/TakenTable.vue";
import reportService from "@/services/report";
import hasPrinting from "@/mixins/hasPrinting";
import hasExcel from "@/mixins/hasExcel";

export default {
  name: "TakenTab",
  mixins: [hasPrinting, hasExcel],
  components: {
    TakenTable,
  },
  props: {
    searchQuery: String,
    dateRange: Array,
    isActiveTab: Boolean,
  },
  data() {
    return {
      data: [],
      isLoading: false,
    };
  },
  computed: {
    headers() {
      return [
        { text: this.$t("r_b"), value: "num", sortable: false },
        { text: this.$t("company"), value: "menu", sortable: false },
        {
          text: this.$t("shift_one"),
          value: "shift_one",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("shift_two"),
          value: "shift_two",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("shift_three"),
          value: "shift_three",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("quantity"),
          value: "total",
          sortable: false,
          align: "center",
        },
      ];
    },
    restaurantId() {
      return this.$store.state.restaurant?.id;
    },
  },
  watch: {
    isPrinting(isPrinting) {
      if (!isPrinting || !this.isActiveTab || !this.data || this.data.length === 0) {
        return;
      }

      this.printTakenTable();
    },
    isExcelDownloading(isDownloading) {
      if (!isDownloading || !this.isActiveTab || !this.data || this.data.length === 0) {
        return;
      }

      this.exportTakenExcel();
    },
    dateRange: {
      handler() {
        this.loadData();
      },
      immediate: true,
    },
  },
  methods: {
    async loadData() {
      if (!this.restaurantId || !this.dateRange || this.dateRange.length !== 2) {
        return;
      }

      this.isLoading = true;
      try {
        const params = {
          date: this.dateRange[0],
          date2: this.dateRange[1],
        };

        const response = await reportService.getTotalGuest(this.restaurantId, params);
        this.data = response.data;
      } catch (error) {
        console.error("Error loading taken data:", error);
        this.data = [];
      } finally {
        this.isLoading = false;
      }
    },
    printTakenTable() {
      const tableItems = this.data.map((item, index) => ({
        num: index + 1,
        menu: item.menu || '',
        shift_one: item.shift_one || '0/0',
        shift_two: item.shift_two || '0/0',
        shift_three: item.shift_three || '0/0',
        total: item.total || '0/0',
      }));

      this.printDocument({
        pageTitle: this.$t('taken'),
        title: this.$t('taken'),
            subtitle: `${this.localeDate(this.dateRange[0])} - ${this.localeDate(
              this.dateRange[1]
            )}`,
        tables: [
          {
            headers: this.headers.map(h => ({ text: h.text, value: h.value, align: h.align })),
            items: tableItems,
          }
        ],
      });
    },
    exportTakenExcel() {
      const tableItems = this.data.map((item, index) => ({
        num: index + 1,
        menu: item.menu || '',
        shift_one: item.shift_one || '0/0',
        shift_two: item.shift_two || '0/0',
        shift_three: item.shift_three || '0/0',
        total: item.total || '0/0',
      }));

      this.downloadExcel({
        fileName: `preuzeto_${this.dateRange[0]}_${this.dateRange[1]}.xlsx`,
        sheets: [
          {
            name: this.$t('taken'),
            title: this.$t('taken'),
            subtitle: `${this.localeDate(this.dateRange[0])} - ${this.localeDate(
              this.dateRange[1]
            )}`,
            headers: this.headers.map(h => ({ text: h.text, value: h.value, align: h.align })),
            items: tableItems,
          }
        ],
      });
    },
  },
};
</script>
